import { render, staticRenderFns } from "./MIPFPerf.vue?vue&type=template&id=6964a93d"
import script from "./MIPFPerf.vue?vue&type=script&lang=js"
export * from "./MIPFPerf.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports